<template>
  <div class="tooltip">
    <div class="tooltip-icon pointer" @mouseover="toggleTooltip" @mouseleave="toggleTooltip">
        <bh-icon :icon="icon"/>
        <v-tooltip
          :value="showTooltip"
          :nudge-bottom="clientY"
          :position-x="clientX"
          max-width="300"
          fixed
          content-class="pos-fixed">
          <p class="text-left">
            {{tooltipContent}}
          </p>
        </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  // Tooltip component wrapper for vutify tooltip component.
  name: 'bh-tooltip',
  props: {
    icon: {
      type: String,
      default: 'info'
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    tooltipPosition: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTooltip: false,
      clientX: 0,
      clientY: 0
    }
  },
  methods: {
    /**
     * @param {Mouse Event} event
     * @description Sets top and left position, and toggles the display of the tooltip.
     */
    toggleTooltip(ev) {
      this.clientX = ev.clientX
      this.clientY = this.tooltipPosition === 'top' ? ev.clientY - 50 : ev.clientY + 25
      this.showTooltip = ev.type === 'mouseover'
    }
  }
}
</script>
<style scoped>

</style>
